'use client';
import { Text } from '@lichtblick/photon/atoms/text/text';
import { CheckboxInput, CheckboxInputProps } from '@lichtblick/photon/molecules/checkbox/checkbox-input';
import { FieldFooterState } from '@lichtblick/photon/molecules/field-footer/field-footer';

import styles from './Checkbox.module.scss';
import { withValidation } from './Form.helpers';

type CheckboxProps = CheckboxInputProps & {
  statusType?: FieldFooterState;
  subLabel?: string;
};

export const Checkbox = withValidation(
  ({ hasError, label, labelSlot, statusType, subLabel, ...props }: CheckboxProps) => (
    <CheckboxInput
      {...props}
      hasError={statusType === 'error' || hasError}
      labelSlot={
        <>
          {label ?? labelSlot}
          {subLabel && (
            <Text className={styles['sub-label']} size="xs">
              {subLabel}
            </Text>
          )}
        </>
      }
    />
  ),
);
